import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import Intl from './base/intl';
import Router from './base/router';
import config from '../config';
import MbApi from '../services/mbapi';
import Emitter from '../services/emitter';
import store from '../reducers';
import action, { defaultLangKey, langKey } from '../reducers/language/action';

MbApi(store);

// 是否是对外的sdk
const isSdk = config.showCopyrightLogo;

const waitLanguageReady = () => {
    return new Promise((res, rej) => {
        if (defaultLangKey === langKey) {
            res();
        } else {
            const timeoutId = setTimeout(() => {
                rej();
            }, 2000);
            store.dispatch(action.change(defaultLangKey));
            Emitter.once('LocaleDataUpdated', () => {
                clearTimeout(timeoutId);
                res();
            });
        }
    });
};

const render = (domId) => {
    ReactDOM.render((
        <Provider store={store}>
            <Intl>
                <Router />
            </Intl>
        </Provider>
    ), document.querySelector(domId));
};

const injectDom = function (domId) {
    if (isSdk) {
        render(domId);
    } else {
        waitLanguageReady().then(() => {
            render(domId);
        });
    }
};

export {
    injectDom
};
